export const config = {
    colors: {
        primary: '#2B2B50',
        secondary: '#FB8A2E',
        white: 'white',
        black: 'black'
    },
    typography: {
        primary: '"Nunito Sans","Helvetica","Arial",sans-serif',
    }
}